import { RouterProvider } from '@tanstack/react-router';
import { router } from './_routes/index.js';

export function App() {
    return <RouterProvider router={router} />;
}
